module.exports = __webpack_public_path__ + "assets/img/problem-illustration.41940a78.png";